import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import useModalState from "hooks/useModalState";
import Modal from "modules/Modal/Modal";
import { useCallback } from "react";
import MDTypography from "components/MDTypography";
import useCreateDailyFormWorkOrder from "hooks/fleet/useCreateDailyFormWorkOrder";
import WorkOrderForm from "./WorkOrderForm";
import { CreateWorkOrderInput } from "DDD/action-objects/WorkOrderEdit";
import { CreateDailyFormWorkOrderInput } from "generated/graphql";

export default function CreateWorkOrderModal() {
  const { open, onClose, onOpen } = useModalState();

  const [createWorkOrder, { loading, error, isSuccess }] = useCreateDailyFormWorkOrder();

  const onSubmit = useCallback(
    async (input: CreateWorkOrderInput) => {
      const result = await createWorkOrder({
        variables: {
          input: {
            ...input,
            neededCompletionDate: input.neededCompletionDate || null,
            currentMeterReading: input.currentMeterReading ?? null,
            estimatedTaskTime: input.estimatedTaskTime ?? null,
            assignedTo: input.assignedTo || null,
            servicePlanId: input.servicePlanId || null,
          } as CreateDailyFormWorkOrderInput,
        },
      });

      if (result.data?.createDailyFormWorkOrder) {
        onClose();
      }
    },
    [createWorkOrder, onClose]
  );

  const modalStyles = {
    height: "auto",
    maxHeight: "90vh",
    width: "90vw",
    maxWidth: "800px",
  };

  return (
    <>
      <MDButton
        type="button"
        variant="gradient"
        color="info"
        onClick={() => {
          onOpen();
        }}
      >
        Create Shop Task
      </MDButton>
      <Modal open={open} onClose={onClose} styles={modalStyles}>
        <MDBox p={3}>
          <MDTypography variant="h5" mb={3}>
            Create Shop Task
          </MDTypography>
          <WorkOrderForm mode="create" onSubmit={onSubmit} loading={loading} onCancel={onClose} />
        </MDBox>
      </Modal>
    </>
  );
}
